import React from "react";

export const BorderGlowFilter: React.FC = () => (
  <svg style={{ position: "fixed", top: 0, left: 0, width: 0, height: 0 }}>
    <defs>
      <filter id="glow" y="-25%" height="150%">
        {/* extract just the gradient border */}
        <feComponentTransfer result="border">
          <feFuncA type="table" tableValues="0 1 0" />
        </feComponentTransfer>

        {/* next 2 primitives just to make glow grainy */}
        {/* blur extracted border */}
        <feGaussianBlur stdDeviation="30" result="blur" />
        {/* create noise */}
        <feTurbulence type="fractalNoise" baseFrequency="1.73" />
        {/* use noise as displacement map for blurred border */}
        <feDisplacementMap
          in="blur"
          scale="50"
          xChannelSelector="R"
          result="displaced"
        />
        {/* smooth the displaced result to prevent abrupt particle ends */}
        <feGaussianBlur in="displaced" stdDeviation="5" />

        {/* place border on top of glow */}
        <feBlend in="border" />
      </filter>
    </defs>
  </svg>
);
